import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { MDBRow } from "mdb-react-ui-kit";
import Layout from "../../Layout/Layout.js";
import MenuDesplegableCategoria from "../../components/Menu_Desplegable_Categoria.js";
import DetallesProductos from "../../Products/Detalles_Producto.js";
import AllProductsSearch from "../../Products/AllProductsSearch.js";
import { BASE_URL } from "../../Routes/global-env.js";
import axios from "axios";
const CategoryList = () => {
  const params = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(params.keyword);
  const getProductsByCat = async () => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/api/productos/producto-categoria/${params.keyword}`
      );
      setProducts(data?.body);
      setCategory(params.keyword);
    } catch (error) {
      setProducts([]);
    }
  };
  getProductsByCat();
  return (
    <Layout>
      <MenuDesplegableCategoria />
      <div className="container">
        <h4 className="text-center">Categoria - {category}</h4>
        {/* <h6 className="text-center">{products?.length} productos</h6> */}
        {products?.length > 1 ? (
          <h6 className="text-center">{products?.length} productos</h6>
        ) : null}
        {products?.length === 1 ? (
          <h6 className="text-center">{products?.length} producto</h6>
        ) : null}
        {products?.length <= 0 ? (
          <h6 className="text-center">No tenemos productos momentaneamente</h6>
        ) : null}
      </div>

      <MDBRow
        className="row home"
        style={{ paddingRight: "0px", margin: "1%" }}
      >
        {/* <div className="d-flex flex-wrap mt-4"> */}
        {products.length === 1 ? (
          <DetallesProductos producto={products} />
        ) : (
          <AllProductsSearch search={products} />
        )}
      </MDBRow>
    </Layout>
  );
};

export default CategoryList;
